/**
 * Breadcrumb Navigation Component
 * Improves navigation and page hierarchy (Week 4 feedback)
 */

import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onNavigate?: (path: string) => void;
}

export function Breadcrumbs({ items, onNavigate }: BreadcrumbsProps) {
  const handleClick = (path: string) => {
    if (onNavigate) {
      onNavigate(path);
    } else {
      // Fallback to window.location if no navigate callback
      window.location.href = path;
    }
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4" aria-label="Breadcrumb">
      <button
        onClick={() => handleClick('/rfp/proposals')}
        className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
        aria-label="Home"
      >
        <Home className="h-4 w-4" />
      </button>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          {item.path && index < items.length - 1 ? (
            <button
              onClick={() => handleClick(item.path!)}
              className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-gray-900 dark:text-gray-100 font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}




